import { apiClient } from "./client";

export interface AwardView {
  id: string;
  prizeName: string;
  prizeType: string;
  source: string;
  status: string;
  awardedAt: string;
  deliveredAt: string | null;
  crypto: {
    currency: string;
    amount: string;
    recipientAddress: string;
    status: string;
    txHash: string | null;
  } | null;
  merch: {
    status: string;
    trackingNumber: string | null;
    carrier: string | null;
  } | null;
  perk: {
    perkCode: string;
    status: string;
    expiresAt: string | null;
  } | null;
}

export async function fetchMyAwards(): Promise<AwardView[]> {
  const { data } = await apiClient.get<AwardView[]>("/me/awards");
  return data;
}

export async function claimCryptoAward(awardId: string, recipientAddress: string): Promise<{ txHash: string }> {
  const { data } = await apiClient.post<{ txHash: string }>(
    `/me/awards/${awardId}/claim-crypto`,
    { recipientAddress }
  );
  return data;
}

export async function claimMerchAward(awardId: string, address: {
  recipientName: string;
  shippingAddress: string;
  city: string;
  country: string;
  postalCode?: string;
  contactPhone?: string;
}): Promise<{ status: string }> {
  const { data } = await apiClient.post<{ status: string }>(
    `/me/awards/${awardId}/claim-merch`,
    address
  );
  return data;
}
